export default "__VITE_ASSET__wb_hD8Zg__"